export enum ModalTypes {
  SIMULATION = 'SIMULATION',
  SIMULATION_SUCCESS = 'SIMULATION_SUCCESS',
  SIMULATION_ERROR = 'SIMULATION_ERROR',
  UNSAVED_CHANGES = 'UNSAVED_CHANGES',
  DELETE = 'DELETE',
  COPY = 'COPY',
  PLACEMENT_INFO = 'PLACEMENT_INFO',
  SCHEME = 'SCHEME',
  SCHEME_SUCCESS = 'SCHEME_SUCCESS',
  HEATING_CALC_INFO = 'HEATING_CALC_INFO',
  COOLING_CALC_INFO = 'COOLING_CALC_INFO',
  PRODUCT_DETAILS = 'PRODUCT_DETAILS',
  LOGIN_FAILURE = 'LOGIN_FAILURE',
  CONFIG_DELETION_WARNING = 'CONFIG_DELETION_WARNING',
  CONFIG_DISABLING_WARNING = 'CONFIG_DISABLING_WARNING',
  CONFIG_KEY_CHANGE_WARNING = 'CONFIG_KEY_CHANGE_WARNING',
  GENERAL = 'GENERAL',
  HELP = 'HELP',
  UPDATE_PROJECT = 'UPDATE_PROJECT',
  DOWNLOAD_SIMULATION_FAILED = 'DOWNLOAD_SIMULATION_FAILED',
  BUFFER_VOLUME_INFO = 'BUFFER_VOLUME_INFO',
  ACCESSORY_SUGGESTION = 'ACCESSORY_SUGGESTION',
  SCHEME_DEBUG_INFO = 'SCHEME_DEBUG_INFO',
  PS_UPLOAD_SUCCESS = 'PS_SIMULATION_SUCCESS',
  PS_UPLOAD_FAILED = 'PS_UPLOAD_FAILED',
  PS_UPDATE_PROJECT = 'PS_UPDATE_PROJECT'
}
